import { Inertia } from '@inertiajs/inertia'

const maxCacheSize = 10
const pageCache = {}

export function addPageCache(component, pageProps) {
  pageCache[component] = pageProps

  if (pageCache.length > maxCacheSize) {
    const keys = Object.keys(pageCache)
    const index = keys.shift()
    delete pageCache[index]
  }
}

export function getPageCache(component) {
  return pageCache[component] || {}
}

export function setPage(page) {
  Inertia.pushState(page)

  return Promise.resolve(Inertia.resolveComponent(page.component)).then((component) => {
    Inertia.swapComponent({ component, page }).then(() => {
      Inertia.resetScrollPositions()
      document.dispatchEvent(new CustomEvent('inertia:navigate', { detail: { page } }))
    })
  })
}
